const Domain = {
    link: "https://lk.silkwayrally.com/api/image/"
};

export default Domain